import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import {
  IGetQueryParams,
  ICreateCategoryGlobalPayload,
} from "../interfaces/Index";
import CategoryGlobalPage from "../components/pages/categoryGlobal/CategoryGlobalPage";

export const mapStateToProps = (state: any, props: any) => {
  return {
    isLoading: state.categoryGlobal.isLoading,
    isError: state.categoryGlobal.isError,
    error: state.categoryGlobal.error,
    isCategoryGlobalAdded: state.categoryGlobal.isCategoryGlobalAdded,
    isFetchCategoryGlobalLoading:
      state.categoryGlobal.isFetchCategoryGlobalLoading,
    isFetchCategoryGlobalError: state.categoryGlobal.isFetchCategoryGlobalError,
    categoriesGlobal: state.categoryGlobal.categoriesGlobal,
    pagination: state.categoryGlobal.pagination,
    isCoreCategoriesGlobalFetched:
      state.categoryGlobal.isCoreCategoriesGlobalFetched,
    coreCategories: state.categoryGlobal.coreCategories,
    isCategoryGlobalUpdated: state.categoryGlobal.isCategoryGlobalUpdated,
    citiesList: state.zone.citiesList,
    isCityListFetched: state.zone.isCityListFetched,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    createCategoryGlobal: (payload: ICreateCategoryGlobalPayload) =>
      dispatch(actions.createCategoryGlobal(payload)),
    getCoreCategoriesGlobal: () => dispatch(actions.getCoreCategoriesGlobal()),
    fetchCategoriesGlobal: (
      isProductDetailPage: boolean,
      queryPrams?: IGetQueryParams
    ) =>
      dispatch(
        actions.getCategoriesGlobalList(isProductDetailPage, queryPrams)
      ),
    updateCategoryGlobal: (id: string, payload: ICreateCategoryGlobalPayload) =>
      dispatch(actions.updateCategoryGlobal(id, payload)),
    fetchCities: () => dispatch(actions.fetchCities()),
  };
};

const CategoryGlobalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryGlobalPage);
export default CategoryGlobalContainer;
